/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MergeUsersDto } from '../../models/merge-users-dto';
import { MergeUsersResponse } from '../../models/merge-users-response';

export interface UserControllerMerge$Params {
      body: MergeUsersDto
}

export function userControllerMerge(http: HttpClient, rootUrl: string, params: UserControllerMerge$Params, context?: HttpContext): Observable<StrictHttpResponse<MergeUsersResponse>> {
  const rb = new RequestBuilder(rootUrl, userControllerMerge.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MergeUsersResponse>;
    })
  );
}

userControllerMerge.PATH = '/user/merge';
